import React from 'react';
import { useTranslation } from 'react-i18next';
import { mobile_app } from '../components/MobileApp/data/mobile_app.json';

/* Checking if the current page is the home page or not. Also some ternary operators to checks if the page 
is under a LOB: FC or SB. */
/**  
* @lobSourceName used to append the result of the ternary operator as the &lob= in the URL to make the request
* @lobDemoSplit this is used for routing
* @lobRoot similar to @lobDemoSplit but when there is no mix on the routes
* @targetLOB used as pointer in the array for the position of the category
*/
const pageUrl = window.location.href;
export const lobSourceName = pageUrl.match(`/sb`) ? '&lob=sb' : pageUrl.match(`/fc`) ? '&lob=fc': pageUrl.match(`/ml`) ? '&lob=ml' : pageUrl.match(`/privatebank`) ? '&lob=pb' : '';
export const lobDemoSplit = pageUrl.match(`/sb`) ? '/sb' : pageUrl.match(`/fc`) ? '/fc' : pageUrl.match(`/ml`) ? '/ml' : pageUrl.match(`/privatebank`) ? '/privatebank' : '';
export const lobRoot = pageUrl.match(`/sb`) ? '/sb/smallbusiness' : pageUrl.match(`/fc`) ? '/fc' : pageUrl.match(`/ml`) ? '/ml' : pageUrl.match(`/privatebank`) ? '/privatebank' : '/';
export const targetLOB = pageUrl.match(`/sb`) ? 2 : pageUrl.match(`/fc`) ? 2 : pageUrl.match(`/ml`) ? 2 : pageUrl.match(`/privatebank`) ? 2 : 1;

export const LobPartnerLabel = pageUrl.match(`/sb`) ? 'Business Advantage' : '';
export const LobPrivateBankLabel = pageUrl.match(`/privatebank`) ? 'Private Bank' : '';

export const LobGetAppWidgetBg = () => {
    const { t } = useTranslation('mobile_app');
    return pageUrl.match(`/sb`) ? <img src={`${process.env.PUBLIC_URL}/assets/images/widget-bg-sb.jpg`} alt={t(mobile_app.bgroundAlt)} /> : <img src={`${process.env.PUBLIC_URL}/assets/images/widget-bg.jpg`} alt={t(mobile_app.bgroundAlt)} />;
}


export const LobConditional = () =>{return pageUrl.match('/') ? false : true;}
export const defaultMetaDescription = "Bank with confidence at home or on the go with help from our step-by-step self-guided demos for Online and Mobile Banking.";